import { FC } from 'react';

export const Dashboard: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 5C3 3.89543 3.89543 3 5 3H9C10.1046 3 11 3.89543 11 5V11C11 12.1046 10.1046 13 9 13H5C3.89543 13 3 12.1046 3 11V5ZM9 5H5V11H9V5ZM13 5C13 3.89543 13.8954 3 15 3H19C20.1046 3 21 3.89543 21 5V7C21 8.10457 20.1046 9 19 9H15C13.8954 9 13 8.10457 13 7V5ZM19 5H15V7H19V5ZM13 13C13 11.8954 13.8954 11 15 11H19C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H15C13.8954 21 13 20.1046 13 19V13ZM19 13H15V19H19V13ZM3 17C3 15.8954 3.89543 15 5 15H9C10.1046 15 11 15.8954 11 17V19C11 20.1046 10.1046 21 9 21H5C3.89543 21 3 20.1046 3 19V17ZM9 17H5V19H9V17Z"
			fill="currentColor"
		/>
	</svg>
);
